/**
 * Created by toomasp on 31.08.2015.
 */
'use strict';
export default ['$parse', ($parse)=> {
    class NgBlurDirective {
        link(scope, element, attr) {
            var fn = $parse(attr['ngBlur']);
            element.bind('blur', function (event) {
                scope.$apply(function () {
                    fn(scope, {
                        $event: event
                    });
                });
            });
        }
    }
    return new NgBlurDirective();
}]


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/decorator/ng-blur.directive.js